import { Layout } from 'react-admin'
import { CustomAppBar } from './CustomAppBar'
import { CustomMenu } from './CustomMenu'
import { IndustryProvider } from '../context/IndustryContext'
import './styles/industryThemes.css'

export const CustomLayout = props => {
   return (
      <IndustryProvider>
         <Layout {...props} appBar={CustomAppBar} menu={CustomMenu}/>
      </IndustryProvider>
   )
}